import { AnalysisCompleteUserStatsWidget } from '../Analysis/AnalysisLeaderboard/AnalysisCompleteUserStatsWidget';
import Can from '../Can';
import { CurrentAnalysisStatsWidget } from '../Analysis/CurrentAnalysisStats/CurrentAnalysisStatsWidget';
// IMPORT PROJECT REFERENCES
import { MonitoredDocumentChangesBrowser } from '../MonitoredDocument/MonitoredDocumentChanges';
// IMPORT PACKAGE REFERENCES
import React from 'react';
import RequestAnalysisAssignment from '../RequestAnalysisAssignment';

// COMPONENT
const HomePage = () => (
    <main>
        <Can I="update" a="ProductAnalysis">
            <div className="row mt-2">
                <RequestAnalysisAssignment />
            </div>
        </Can>
        <div className="row mt-2">
            <div className="col-sm">
                <Can I="create" a="ProductAnalysis">
                    <CurrentAnalysisStatsWidget />
                    <AnalysisCompleteUserStatsWidget />
                </Can>
            </div>
            <div className="col-sm">
                <Can I="read" a="Document">
                    <MonitoredDocumentChangesBrowser />
                </Can>
            </div>
        </div>
    </main>
);

export { HomePage };
